import { el } from './dom';

export type NavLink = { href: string; label: string };

export type NavProps = {
  links?: NavLink[];
};

const DEFAULTS: NavLink[] = [
  { href: '/why', label: 'why' },
  { href: '/blog', label: 'blog' },
];

export const Nav = (props: NavProps = {}): HTMLElement => {
  const links = props.links ?? DEFAULTS;
  const linkHtml = links.map((l) => `<a href="${l.href}">${l.label}</a>`).join('');
  return el(`
    <nav>
      <div class="container inner">
        <a class="wordmark" href="/" aria-label="anomia home">anomia<span class="wordmark-period">.</span></a>
        <div class="nav-links">${linkHtml}</div>
      </div>
    </nav>
  `);
};
